module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMTkuODEzIiBoZWlnaHQ9IjM4Ny41MDgiIHZpZXdCb3g9IjAgMCAxMTkuODEzIDM4Ny41MDgiPgogIDxwYXRoIGlkPSLjg5HjgrlfMzc0NSIgZGF0YS1uYW1lPSLjg5HjgrkgMzc0NSIgZD0iTTg1NS4wMjYtMTEwLjEsOTc0Ljg0LTE1NS41MXYzNDIuMUw4NTUuMDI2LDIzMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04NTUuMDI2IDE1NS41MSkiIGZpbGw9InJlZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/red_120.svg
// module id = xv6W
// module chunks = 0